import React from 'react';
import styled, { keyframes } from 'styled-components';


const fadeIn = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 0.6;
  }
`;

const fadeOut = keyframes`
  from {
    opacity: 0.6;
  }

  to {
    opacity: 0;
  }
`;

const StyledBackdrop = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  background: black;
  z-index: 100;
  top: 0;
  left: 0;
  opacity: 0.6;
  animation: ${({ isOpen }) => isOpen ? fadeIn : fadeOut} 0.4s;
`;

export default function Backdrop({ isOpen }) {
  return (
    <StyledBackdrop isOpen={isOpen} />
  )
}